module.exports = __webpack_public_path__ + "static/media/CaskShare_August 2023)-21.4b81b92f.jpg";